import { ChatRoomMessageChannel } from '@commenda/prisma';
import { FileBasic } from '@commenda/types/src/file/types';
import { fetcher } from '@commenda/utils';
import { ChatRoomMessageType } from '@prisma/client';

export async function sendMessage(
  {
    chatRoomId,
    message,
    messageType,
    sentAt,
    files,
    replyToMessageId,
    isInternalNoteMessage,
    channel,
    mentionedUserIds,
    mentionsAgent,
  }: {
    messageType: ChatRoomMessageType;
    message: string;
    sentAt: Date;
    chatRoomId: string;
    files: FileBasic[];
    replyToMessageId?: string;
    isInternalNoteMessage?: boolean;
    /** Explicit channel override — use for CUSTOMER_INTERNAL messages sent from the customer UI. */
    channel?: ChatRoomMessageChannel;
    /** Re-validated server side against the thread's own candidates before anything is stored. */
    mentionedUserIds?: string[];
    mentionsAgent?: boolean;
  },
  token: string
): Promise<boolean> {
  const res = await fetcher(
    `chatRoom/${chatRoomId}/message`,
    {
      method: 'POST',
      body: {
        messageType,
        message,
        sentAt: sentAt?.toISOString(),
        files: files || [],
        replyToMessageId,
        isInternalNoteMessage,
        channel,
        mentionedUserIds,
        mentionsAgent,
      },
    },
    token
  );

  return res.ok;
}
